var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.getters.getMyBusinessNewsStatus === 'loading')?_c('page-preloader'):(_vm.announcement)?_c('announcement-preview',{attrs:{"announcement":_vm.announcement,"active-id":_vm.announcement.id,"clickable":false,"show-new-badge":""}}):_c('div',[_vm._v("Brak wyników")])
}
var staticRenderFns = []

export { render, staticRenderFns }